import cn from 'classnames';
import styles from './Projects.module.scss';
import { Title } from '@/components/Title';
import { Gallery } from '@/components/Gallery';
import { Button } from '@/components/Button';
import { useTranslations } from 'next-intl';
import { FramerBlock } from '@/components/FramerBlock';
import { Arrow } from '@/components/Arrow';
import { useRouter } from 'next/navigation';
import { PROJECTS } from '@/constants';

type ProjectsProps = {
  className?: string;
};

export function Projects({ className }: ProjectsProps) {
  const wrapperClassName = cn(styles.wrapper, className);
  const t = useTranslations();
  const { push } = useRouter();

  const handleGithubClick = () => {
    window.open('https://github.com/boymep');
  };

  const handleMoreClick = () => {
    push('/cases');
  };

  return (
    <div className={wrapperClassName} id="cases">
      <FramerBlock
        transition={0.6}
        variants={{
          visible: { transform: 'translateY(0%)', opacity: 1 },
          hidden: { transform: 'translateY(20%)', opacity: 0 },
        }}
        className={styles.frame}
      >
        <Gallery items={PROJECTS} className={styles.gallery} />
        <div className={styles.buttons}>
          <div className={styles.learnMore}>
            <Button
              text={t('cases.all')}
              onClick={handleMoreClick}
              customIcon={<Arrow className={styles.arrow} />}
              animatedIcon
            />
          </div>
          <div className={styles.github}>
            <Button
              text="Github"
              onClick={handleGithubClick}
              customIcon={<Arrow className={styles.arrow} />}
              animatedIcon
            />
          </div>
        </div>
      </FramerBlock>
      <div className={styles.info}>
        <Title text={t('cases.title')} className={styles.title} />
        <img
          src="/webp/keyboard.webp"
          alt="keyboard"
          className={styles.img}
          loading="lazy"
        />
        <div className={styles.empty} />
      </div>
    </div>
  );
}
